import disableScroll from "./disable-scroll";
import enableScroll from "./enable-scroll";

export default () => {
	const navButton = document.querySelector('.navbar-toggler');

	if (!navButton) return;

	const header = document.querySelector('.header'),
		caret = document.querySelectorAll('.caret'),
		navPrimary = document.querySelector('.nav-primary'),
		submenuTitle = document.querySelector('.submenu-title'),
		submenuBack = document.querySelector('.submenu-back'),
		dropDowns = document.querySelectorAll('.dropdown'),
		dropDownToggle = document.querySelectorAll('.dropdown-toggle'),
		mobile = window.matchMedia("(min-width: 1300px)");

	function addHeaderOpenClass () {
		if (!mobile.matches) {
			header.classList.add('open-second-level');
			navPrimary.scrollTop = 0;
		}
	}

	function openMobileDropDown() {
		caret.forEach(item => {
			item.addEventListener('click', function () {
				item.closest('.dropdown').classList.add('dropdown-open');
				submenuTitle.textContent = item.closest('a').getAttribute('title');
				addHeaderOpenClass();
			});
		})
	}

	function openMobileDropDownLink() {
		dropDownToggle.forEach(item => {
			item.addEventListener('click', function () {
				if (this.getAttribute('href') === '#') {
					this.closest('.dropdown').classList.add('dropdown-open');
					submenuTitle.textContent = this.getAttribute('title');
					addHeaderOpenClass();
				}
			})
		})
	}

	function closeDropDown() {
		dropDowns.forEach(item => {
			item.classList.remove('dropdown-open');
			header.classList.remove('open-second-level');
			submenuTitle.textContent = '';
		})
	}

	openMobileDropDown();

	if (!mobile.matches) { openMobileDropDownLink(); }

	navButton.addEventListener('click', function () {
		this.classList.toggle('active');
		header.classList.toggle('open');
		document.body.classList.toggle('overflow');

		document.body.classList.contains('overflow') ? disableScroll() : enableScroll();

		header.classList.contains('open') ? false : closeDropDown();
	});

	submenuBack.addEventListener('click', function (){
		closeDropDown();
	})

	window.addEventListener('resize', ()=> {
		if (mobile.matches) {
			navButton.classList.remove('active')
			header.classList.remove('open');
			document.body.classList.remove('overflow');
			closeDropDown();
			enableScroll();
		} else {
			openMobileDropDownLink();
		}
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/nav-mobile.js